<template lang="pug">
  div.order-steps.my-2
    template(v-for="(s, ix) in steps")
      div.step(
        :class="{ 'completed': ix + 1 < currentStep, 'current': ix + 1 === currentStep, 'failed': failure }"
        )
        div.step-number
          div {{ ix + 1 }}
        div.step-text
          | {{ s }}
</template>

<script>
export default {
  name: 'OrderStep',
  props: {
    currentStep: {
      type: Number,
      required: true,
      default: 1
    },
    failure: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    steps: [
      'Bestellung vorbereiten',
      'Menge prüfen',
      'Lieferung',
      'Zahlung',
      'Auftrag bestätigen'
    ]
  })
}
</script>

<style lang="stylus" scoped>
  div.order-steps
    display flex
    flex-wrap wrap
    justify-content center
    background-color rgba(0,0,0,0.05)
    padding 8px

    div.step
      display flex
      flex-direction column
      vertical-align middle
      align-items center
      padding-left 15px
      padding-right 15px

      div.step-number
        display flex
        align-items center
        justify-content center
        font-weight bold
        color rgba(0, 0, 0, 0.5)
        width 32px
        height 32px
        border 2px solid rgba(0, 0, 0, 0.5)
        border-radius 50%

      div.step-text
        text-align center

      &.completed

        .step-number
          background-color var(--success)
          color white

      &.current

        .step-number
          background-color var(--primary)
          color white

      &.current.failed
        .step-number
          background-color var(--danger)

  @media (max-width 800px)
    div.order-steps

      div.step
        padding-left 8px
        padding-right 8px

        div.step-text
          font-size 80%

  @media (max-width 640px)
    div.order-steps
      div.step
        div.step-number
          width 24px
          height 24px
          font-size 80%

        div.step-text
          display none
</style>
